import React from 'react';

import filterIcon from '../../images/filter_alt-24px.svg';
import blueFilterIcon from '../../images/bluefilter_alt-24px.svg';

/**
 * Thead component.
 * @param {object} props
 * @returns {jsx}
 */
function Thead(props){
  let columns = [];

  for(let i=0, columnDef;(columnDef = props.columns[i]);i++){
    let column = _renderColumnHeader(props, columnDef);
    columns.push(column);
  }

  return (
    <thead>
      <tr>
        <td><div className="header-space"></div></td>
      </tr>
      <tr>
      {columns}
      </tr>
    </thead>
  );
}


/**
 *
 */
function _renderColumnHeader(props, columnDef){
  let columnKey = "col_" + columnDef.id;

  let className=null;
  if(props.sort && props.sort[columnDef.id]){
    className = props.sort[columnDef.id];
  }


  let column = (
    <th
    key={columnKey}
    id={columnDef.id}
    onClick={props.columnSort}
    className={className+' sortable'}>
      {columnDef.label}
      {_renderFilterIcon(props, columnDef)}
    </th>
  );

  if(columnDef.sortable === false){
    column = (
      <th
        key={columnKey}
        id={columnDef.id}
        className={className}>
          {columnDef.label}
          {_renderFilterIcon(props, columnDef)}
      </th>
    );
  }

  return column;
}

/**
 *
 */
 function _renderFilterIcon(props, columnDef){
   if(columnDef.filter && props.filter && props.filter[columnDef.id]){
     return (
       <img
         alt="Set Filter"
         className="filter"
         title="set filter"
         src={props.filterSetIcon||blueFilterIcon}
         onClick={_clickFilter.bind(this, props, columnDef)}
       />
     );
   } else if(columnDef.filter){
     return (
       <img
         alt="Set Filter"
         className="filter"
         title="set filter"
         src={props.filterIcon||filterIcon}
         onClick={_clickFilter.bind(this, props, columnDef)}
       />
     );
   }else{
     return null;
   }
}


/**
 *
 */
function _clickFilter(props, columnDef){
  let state = Object.assign({},props.localState);
  state.filterDisplay = "open";
  state.SelectedFilterColumn=columnDef;
  props.updateLocalState(state);
}

export default Thead;
